var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontToBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_91)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    transform: "matrix(-1 0 0 1 24 -9.53674e-07)",
    fill: "#58914A"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0 -1 -1 0 5 35)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0 -1 -1 0 23 35)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0 -1 -1 0 17 35)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0 -1 -1 0 11 35)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0 -1 -1 0 -1 35)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7703 11.4789V10.9789",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 11.4789V10.9789",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 13.0063V12.5063",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7703 13.0063V12.5063",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9867 10.6407H13.6791C13.6273 10.5865 13.5584 10.5324 13.4711 10.482C13.3494 10.4116 13.1996 10.353 13.029 10.3121C12.8586 10.2714 12.6742 10.25 12.4867 10.25C12.2993 10.25 12.1148 10.2714 11.9445 10.3121C11.7739 10.353 11.6241 10.4116 11.5024 10.482C11.415 10.5324 11.3461 10.5865 11.2943 10.6407H10.9867C11.0013 10.6132 11.0181 10.5862 11.0372 10.5596C11.116 10.4496 11.2316 10.3497 11.3773 10.2655C11.523 10.1813 11.6959 10.1146 11.8863 10.069C12.0767 10.0234 12.2807 10 12.4867 10C12.6928 10 12.8968 10.0234 13.0871 10.069C13.2775 10.1146 13.4505 10.1813 13.5961 10.2655C13.7418 10.3497 13.8574 10.4496 13.9363 10.5596C13.9553 10.5862 13.9722 10.6132 13.9867 10.6407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9867 10.6407V13.1407C13.9867 13.4168 13.7629 13.6407 13.4867 13.6407H11.4867C11.2106 13.6407 10.9867 13.4168 10.9867 13.1407V10.6407H11.2367V13.1407C11.2367 13.2787 11.3486 13.3907 11.4867 13.3907H13.4867C13.6248 13.3907 13.7367 13.2787 13.7367 13.1407V10.6407H13.9867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.1,
    x2: 0.1,
    y2: -0.1,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 11.1652 10.7683)",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.6996,
    y1: 10.6622,
    x2: 13.7703,
    y2: 10.5915,
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.875,
    cy: 0.875,
    r: 0.775,
    transform: "matrix(-1 0 0 1 13.3602 11.0063)",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4102 13.4831H11.5602V16.1581C11.5602 16.2548 11.6385 16.3331 11.7352 16.3331H13.2352C13.3318 16.3331 13.4102 16.2548 13.4102 16.1581V13.4831Z",
    stroke: "white",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3968 1.75536C12.4456 1.70655 12.5247 1.70655 12.5735 1.75536L13.369 2.55086C13.4179 2.59967 13.4179 2.67882 13.369 2.72763C13.3202 2.77645 13.2411 2.77645 13.1923 2.72763L12.4852 2.02053L11.778 2.72763C11.7292 2.77645 11.6501 2.77645 11.6013 2.72763C11.5525 2.67882 11.5525 2.59967 11.6013 2.55086L12.3968 1.75536ZM12.3602 9.59375C12.3602 9.52471 12.4161 9.46875 12.4852 9.46875C12.5542 9.46875 12.6102 9.52471 12.6102 9.59375H12.3602ZM12.6102 9.09375C12.6102 9.16279 12.5542 9.21875 12.4852 9.21875C12.4161 9.21875 12.3602 9.16279 12.3602 9.09375H12.6102ZM12.3602 8.59375C12.3602 8.52471 12.4161 8.46875 12.4852 8.46875C12.5542 8.46875 12.6102 8.52471 12.6102 8.59375H12.3602ZM12.6102 8.09375C12.6102 8.16279 12.5542 8.21875 12.4852 8.21875C12.4161 8.21875 12.3602 8.16279 12.3602 8.09375H12.6102ZM12.3602 7.59375C12.3602 7.52471 12.4161 7.46875 12.4852 7.46875C12.5542 7.46875 12.6102 7.52471 12.6102 7.59375H12.3602ZM12.6102 7.09375C12.6102 7.16279 12.5542 7.21875 12.4852 7.21875C12.4161 7.21875 12.3602 7.16279 12.3602 7.09375H12.6102ZM12.3602 6.59375C12.3602 6.52471 12.4161 6.46875 12.4852 6.46875C12.5542 6.46875 12.6102 6.52471 12.6102 6.59375H12.3602ZM12.6102 6.09375C12.6102 6.16279 12.5542 6.21875 12.4852 6.21875C12.4161 6.21875 12.3602 6.16279 12.3602 6.09375H12.6102ZM12.3602 5.59375C12.3602 5.52471 12.4161 5.46875 12.4852 5.46875C12.5542 5.46875 12.6102 5.52471 12.6102 5.59375H12.3602ZM12.6102 5.09375C12.6102 5.16279 12.5542 5.21875 12.4852 5.21875C12.4161 5.21875 12.3602 5.16279 12.3602 5.09375H12.6102ZM12.3602 4.59375C12.3602 4.52471 12.4161 4.46875 12.4852 4.46875C12.5542 4.46875 12.6102 4.52471 12.6102 4.59375H12.3602ZM12.6102 4.09375C12.6102 4.16279 12.5542 4.21875 12.4852 4.21875C12.4161 4.21875 12.3602 4.16279 12.3602 4.09375H12.6102ZM12.3602 3.59375C12.3602 3.52471 12.4161 3.46875 12.4852 3.46875C12.5542 3.46875 12.6102 3.52471 12.6102 3.59375H12.3602ZM12.6102 3.09375C12.6102 3.16279 12.5542 3.21875 12.4852 3.21875C12.4161 3.21875 12.3602 3.16279 12.3602 3.09375H12.6102ZM12.3602 2.59375C12.3602 2.52471 12.4161 2.46875 12.4852 2.46875C12.5542 2.46875 12.6102 2.52471 12.6102 2.59375H12.3602ZM12.6102 2.09375C12.6102 2.16279 12.5542 2.21875 12.4852 2.21875C12.4161 2.21875 12.3602 2.16279 12.3602 2.09375H12.6102ZM12.3602 9.84375V9.59375H12.6102V9.84375H12.3602ZM12.3602 9.09375V8.59375H12.6102V9.09375H12.3602ZM12.3602 8.09375V7.59375H12.6102V8.09375H12.3602ZM12.3602 7.09375V6.59375H12.6102V7.09375H12.3602ZM12.3602 6.09375V5.59375H12.6102V6.09375H12.3602ZM12.3602 5.09375V4.59375H12.6102V5.09375H12.3602ZM12.3602 4.09375V3.59375H12.6102V4.09375H12.3602ZM12.3602 3.09375V2.59375H12.6102V3.09375H12.3602ZM12.3602 2.09375V1.84375H12.6102V2.09375H12.3602ZM12.3968 1.75536C12.4456 1.70655 12.5247 1.70655 12.5735 1.75536L13.369 2.55086C13.4179 2.59967 13.4179 2.67882 13.369 2.72763C13.3202 2.77645 13.2411 2.77645 13.1923 2.72763L12.4852 2.02053L11.778 2.72763C11.7292 2.77645 11.6501 2.77645 11.6013 2.72763C11.5525 2.67882 11.5525 2.59967 11.6013 2.55086L12.3968 1.75536ZM12.3602 9.59375C12.3602 9.52471 12.4161 9.46875 12.4852 9.46875C12.5542 9.46875 12.6102 9.52471 12.6102 9.59375H12.3602ZM12.6102 9.09375C12.6102 9.16279 12.5542 9.21875 12.4852 9.21875C12.4161 9.21875 12.3602 9.16279 12.3602 9.09375H12.6102ZM12.3602 8.59375C12.3602 8.52471 12.4161 8.46875 12.4852 8.46875C12.5542 8.46875 12.6102 8.52471 12.6102 8.59375H12.3602ZM12.6102 8.09375C12.6102 8.16279 12.5542 8.21875 12.4852 8.21875C12.4161 8.21875 12.3602 8.16279 12.3602 8.09375H12.6102ZM12.3602 7.59375C12.3602 7.52471 12.4161 7.46875 12.4852 7.46875C12.5542 7.46875 12.6102 7.52471 12.6102 7.59375H12.3602ZM12.6102 7.09375C12.6102 7.16279 12.5542 7.21875 12.4852 7.21875C12.4161 7.21875 12.3602 7.16279 12.3602 7.09375H12.6102ZM12.3602 6.59375C12.3602 6.52471 12.4161 6.46875 12.4852 6.46875C12.5542 6.46875 12.6102 6.52471 12.6102 6.59375H12.3602ZM12.6102 6.09375C12.6102 6.16279 12.5542 6.21875 12.4852 6.21875C12.4161 6.21875 12.3602 6.16279 12.3602 6.09375H12.6102ZM12.3602 5.59375C12.3602 5.52471 12.4161 5.46875 12.4852 5.46875C12.5542 5.46875 12.6102 5.52471 12.6102 5.59375H12.3602ZM12.6102 5.09375C12.6102 5.16279 12.5542 5.21875 12.4852 5.21875C12.4161 5.21875 12.3602 5.16279 12.3602 5.09375H12.6102ZM12.3602 4.59375C12.3602 4.52471 12.4161 4.46875 12.4852 4.46875C12.5542 4.46875 12.6102 4.52471 12.6102 4.59375H12.3602ZM12.6102 4.09375C12.6102 4.16279 12.5542 4.21875 12.4852 4.21875C12.4161 4.21875 12.3602 4.16279 12.3602 4.09375H12.6102ZM12.3602 3.59375C12.3602 3.52471 12.4161 3.46875 12.4852 3.46875C12.5542 3.46875 12.6102 3.52471 12.6102 3.59375H12.3602ZM12.6102 3.09375C12.6102 3.16279 12.5542 3.21875 12.4852 3.21875C12.4161 3.21875 12.3602 3.16279 12.3602 3.09375H12.6102ZM12.3602 2.59375C12.3602 2.52471 12.4161 2.46875 12.4852 2.46875C12.5542 2.46875 12.6102 2.52471 12.6102 2.59375H12.3602ZM12.6102 2.09375C12.6102 2.16279 12.5542 2.21875 12.4852 2.21875C12.4161 2.21875 12.3602 2.16279 12.3602 2.09375H12.6102ZM12.3602 9.84375V9.59375H12.6102V9.84375H12.3602ZM12.3602 9.09375V8.59375H12.6102V9.09375H12.3602ZM12.3602 8.09375V7.59375H12.6102V8.09375H12.3602ZM12.3602 7.09375V6.59375H12.6102V7.09375H12.3602ZM12.3602 6.09375V5.59375H12.6102V6.09375H12.3602ZM12.3602 5.09375V4.59375H12.6102V5.09375H12.3602ZM12.3602 4.09375V3.59375H12.6102V4.09375H12.3602ZM12.3602 3.09375V2.59375H12.6102V3.09375H12.3602ZM12.3602 2.09375V1.84375H12.6102V2.09375H12.3602Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontToBack);
export default __webpack_public_path__ + "static/media/Front-To-Back.bc45a5fa5918893d21cfab91e0409d0d.svg";
export { ForwardRef as ReactComponent };